export interface ExternalFeedProduct {
  id: string;
  photo: string;
  price: number;
  subtitle: string;
  title: string;
  isChecked: boolean;
}
